import { render, staticRenderFns } from "./SlotsListElement.vue?vue&type=template&id=6620718e&"
import script from "./SlotsListElement.vue?vue&type=script&lang=js&"
export * from "./SlotsListElement.vue?vue&type=script&lang=js&"
import style0 from "./SlotsListElement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports